import { Observable, Subject, throttleTime } from "rxjs";

export function onResize$(
  observedElement: HTMLElement
): Observable<ResizeObserverEntry> {
  const result: Subject<ResizeObserverEntry> = new Subject();
  const resizeObserver = new ResizeObserver((elements) => {
    const element = elements.find((entry) => entry.target === observedElement);
    if (element) {
      result.next(element);
    }
  });
  resizeObserver.observe(observedElement);
  return result.pipe(throttleTime(50));
}
